
$(document).ready(function() {
  'use strict';

  var $container = $('#dna_surveys');
  if (!$container.length) return false;

  // ========================================
  //            JS for DNA Surveys
  // ========================================

  const ids = {
    19:'into-the-black-blend',
    20: 'streetlight-blend',
    21: 'sumatra',
    22: 'throwback-blend',
    23: 'daydream-blend',
    24: 'a-day-in-the-life-blend',
    89: 'lights-out-decaf',
    41: 'ruckus-blend',
    42: 'wanderer-blend',
    43: 'fascination-blend',
    44: 'shoulders-of-giants-blend',
    56: 'single-origin-roasters-choice-dark',
    57: 'single-origin-roasters-choice-medium-dark',
    58: 'single-origin-roasters-choice-medium-light',
    45: 'roasters-choice',
    122: 'exploration-single-origin-roasters-choice',
  }

  var $continueButton = $container.find('#js-survey-continue');
  var $coffeeCompanySelect = $container.find('.js-coffeeCompany');
  var $companyId = $container.find('#company_id');
  var $coffeeId = $container.find('#coffee_id');

  // Initialize selectize.js dropdown
  $coffeeCompanySelect.selectize({
    plugins: ['selectize-plugin-a11y'],
    render: {
      option: function($item, escape) {
        // Every option must have a unique id
        return '<div class="option" role="option" id="'+escape($item.text).replace(' ', '')+'">'+escape($item.text)+'</div>'
      }
    },
    load: function(query, callback) {
      $('#surveyError').hide();
      if (!query.length) {
        $('.selectize-no-results').hide();
        return callback()
      }
      $.getJSON('https://dashboard.craftcoffee.com/survey_coffee_search', {q:query}, function (data) {
        $('.selectize-no-results').toggle(data.length <= 0);
        callback(data);
      })
      .fail(function () {
        $('#surveyError').show();
        callback();
      });
    },
    onChange: function (value) {
      var values = (value || '').split('-');
      $companyId.val(values[0]);
      $coffeeId.val(values[1]);
      if (value == '') {
        $continueButton.attr('aria-disabled', true).attr('href', 'javascript:');
      } else {
        $continueButton.removeAttr('aria-disabled').attr('href', `/products/${ids[values[2]] || ''}`);
      }
    },
    // options that have a better match will be sorted first, then alphabetically
    // if the search matches the beginning of the company name, that will show up first
    sortField: [{field:'freq',direction:'desc'}, {field:'text'}]
  });
});